import React, { useEffect } from 'react';
import styled from 'styled-components';
import AccountDeletion from '../components/AccountDeletion/AccountDeletion';

const PageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(100vh - 140px);
  margin-top: 140px;
  padding: ${({ theme }) => `${theme.spacing.xxl} ${theme.spacing.lg}`};
  background: linear-gradient(135deg, ${({ theme }) => theme.colors.background} 0%, ${({ theme }) => `${theme.colors.primary}11`} 100%);
  
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    min-height: calc(100vh - 90px);
    margin-top: 90px;
    padding: ${({ theme }) => `${theme.spacing.xl} ${theme.spacing.md}`};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    min-height: calc(100vh - 80px);
    margin-top: 80px;
    padding: ${({ theme }) => `${theme.spacing.lg} ${theme.spacing.sm}`};
  }
`;

const AccountDeletionPage: React.FC = () => {
  useEffect(() => {
    document.title = 'Delete Account - Radyofone | Account Deletion Request';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', 'Request deletion of your Radyofone account. We process deletion requests within 30 days. Your data and profile will be permanently removed.');
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', 'https://www.radyofone.com/account-deletion');
  }, []);

  return (
    <PageContainer>
      <AccountDeletion />
    </PageContainer>
  );
};

export default AccountDeletionPage;

